export default __webpack_public_path__ + "static/media/home-dog.a717f27c.png";